import { gtagLineEvent } from "@/utils/gtag";

const LINE_URL = "https://lin.ee/shi2rgi";
const GTAG_EVENT = "YAMEBI_1_LINE友達追加_ファーストビュー";

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex flex-col items-center justify-center overflow-hidden">
      {/* 背景画像 */}
      <div className="absolute inset-0">
        <img
          src="https://static.readdy.ai/image/b17b44323c7eb3fa784eb391778099fd/38c10c9284b4d4018d19db525bd52cf2.png"
          alt="夜にお菓子を食べながら自己嫌悪している女性"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/55 to-black/75"></div>
      </div>

      {/* コンテンツ */}
      <div className="relative z-10 w-full max-w-3xl mx-auto px-6 pt-32 pb-24 text-center flex flex-col items-center">
        {/* ロゴは削除（ヘッダーに既にあるため） */}

        {/* メインコピー強調 */}
        <div className="mb-5">
          <p className="inline-block text-white text-xl md:text-2xl lg:text-4xl font-black tracking-tight leading-tight border-b-2 border-white/60 pb-2 whitespace-nowrap">
            「やめたいのに、やめられない…」
          </p>
        </div>

        <h1 className="text-white text-4xl md:text-6xl font-black leading-tight tracking-tight mb-8">
          YAMEBIなら<br />
          <span className="text-[#66E066]">意志力不要</span>で<br />
          <span className="text-[#66E066]">"やめられる"</span>
        </h1>

        {/* サブコピー */}
        <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl px-6 py-4 mb-10 max-w-xl">
          <p className="text-white text-sm md:text-base leading-relaxed font-medium">
            YAMEBIは、お菓子・ジャンクフードなど特定の飲食物の購入にルールをかけ、<strong className="text-[#99F099]">買えない仕組みをつくる購入コントロールサービス</strong>です。
          </p>
        </div>

        {/* LINE追加ボタン */}
        <a
          href={LINE_URL}
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => { e.preventDefault(); gtagLineEvent(LINE_URL, GTAG_EVENT); }}
          className="whitespace-nowrap flex items-center justify-center gap-3 bg-[#00B900] hover:bg-[#009900] text-white font-bold text-lg py-4 px-10 rounded-full transition-all cursor-pointer mb-3 shadow-[0_8px_30px_rgba(0,185,0,0.55)] hover:shadow-[0_12px_40px_rgba(0,185,0,0.7)] hover:scale-105"
        >
          <span className="w-7 h-7 flex items-center justify-center">
            <i className="ri-line-fill text-2xl"></i>
          </span>
          公式LINEを友だち追加
        </a>
        <p className="text-white/70 text-sm mb-14">まずはLINEで仕組みを確認</p>

        {/* 下スクロール案内 */}
        <div className="flex flex-col items-center gap-2">
          <p className="text-white/50 text-xs tracking-widest uppercase">scroll</p>
          <div className="animate-bounce w-5 h-5 flex items-center justify-center text-white/40">
            <i className="ri-arrow-down-s-line text-xl"></i>
          </div>
        </div>
      </div>
    </section>
  );
}
